import { render, staticRenderFns } from "./mail-component.vue?vue&type=template&id=30e8dd47&scoped=true"
import script from "./mail-component.vue?vue&type=script&lang=js"
export * from "./mail-component.vue?vue&type=script&lang=js"
import style0 from "./mail-component.vue?vue&type=style&index=0&id=30e8dd47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e8dd47",
  null
  
)

export default component.exports